import { render, staticRenderFns } from "./HistoryComplaintList.vue?vue&type=template&id=5940f09c"
import script from "./HistoryComplaintList.vue?vue&type=script&lang=js"
export * from "./HistoryComplaintList.vue?vue&type=script&lang=js"
import style0 from "./HistoryComplaintList.vue?vue&type=style&index=0&id=5940f09c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports